export const BRAND = {
  name: 'Gara-Jani Fashions',
  addressLine1: 'GARA FASHIONS',
  addressLine2: '188/120, Munamalewatta, Kiriwattuduwa.',
  telephone: ' 011 275 3960 / 078 149 4482',
  localStorageKey: 'GaraJaniFashions',
};

export const formatAddress = () => `${BRAND.addressLine1}, ${BRAND.addressLine2}`;
